import { useCallback, useSyncExternalStore } from 'react';

export const MOBILE_BREAKPOINT = 768;

export function useMediaQuery(query: string): boolean {
  // React resubscribes whenever the subscribe identity changes.
  const subscribe = useCallback(
    (callback: () => void) => {
      const mediaQuery = window.matchMedia(query);
      mediaQuery.addEventListener('change', callback);
      return () => mediaQuery.removeEventListener('change', callback);
    },
    [query],
  );
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(query).matches,
    () => false,
  );
}

export function useIsMobile() {
  return useMediaQuery(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`);
}

export function useIsTouchDevice() {
  return useMediaQuery('(pointer: coarse)');
}
